import _noop from "lodash/noop";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";

/* eslint-disable max-len */

/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FixedSizeList as List } from 'react-window';
import PaginationFoundation from '@douyinfe/semi-foundation/lib/es/pagination/foundation';
import { cssClasses, numbers } from '@douyinfe/semi-foundation/lib/es/pagination/constants';
import '@douyinfe/semi-foundation/lib/es/pagination/pagination.css';
import { numbers as popoverNumbers } from '@douyinfe/semi-foundation/lib/es/popover/constants';
import { IconChevronLeft, IconChevronRight } from '@douyinfe/semi-icons';
import warning from '@douyinfe/semi-foundation/lib/es/utils/warning';
import ConfigContext from '../configProvider/context';
import LocaleConsumer from '../locale/localeConsumer';
import Select from '../select/index';
import InputNumber from '../inputNumber/index';
import BaseComponent from '../_base/baseComponent';
import Popover from '../popover/index';
const prefixCls = cssClasses.PREFIX;
const {
  Option
} = Select;
export default class Pagination extends BaseComponent {
  constructor(props) {
    var _context, _context2;

    super(props);
    this.state = {
      total: props.total,
      showTotal: props.showTotal,
      currentPage: props.currentPage || props.defaultCurrentPage,
      pageSize: props.pageSize || props.pageSizeOpts[0] || numbers.DEFAULT_PAGE_SIZE,
      pageList: [],
      prevDisabled: false,
      nextDisabled: false,
      restLeftPageList: [],
      restRightPageList: [],
      quickJumpPage: ''
    };
    this.foundation = new PaginationFoundation(this.adapter);
    this.renderDefaultPage = _bindInstanceProperty(_context = this.renderDefaultPage).call(_context, this);
    this.renderSmallPage = _bindInstanceProperty(_context2 = this.renderSmallPage).call(_context2, this);
    warning(Boolean(props.showSizeChanger && props.hideOnSinglePage), '[Semi Pagination] You should not use showSizeChanger and hideOnSinglePage in ths same time. At this time, hideOnSinglePage no longer takes effect, otherwise there may be a problem that the switch entry disappears');
  }

  get adapter() {
    return _Object$assign(_Object$assign({}, super.adapter), {
      setPageList: pageListState => {
        const {
          pageList,
          restLeftPageList,
          restRightPageList
        } = pageListState;
        this.setState({
          pageList,
          restLeftPageList,
          restRightPageList
        });
      },
      setDisabled: (prevIsDisabled, nextIsDisabled) => {
        this.setState({
          prevDisabled: prevIsDisabled,
          nextDisabled: nextIsDisabled
        });
      },
      updateTotal: total => this.setState({
        total
      }),
      updatePageSize: pageSize => this.setState({
        pageSize
      }),
      updateQuickJumpPage: quickJumpPage => this.setState({
        quickJumpPage
      }),
      // updateRestPageList: () => {},
      setCurrentPage: pageIndex => {
        this.setState({
          currentPage: pageIndex
        });
      },
      registerKeyDownHandler: handler => {
        document.addEventListener('keydown', handler);
      },
      unregisterKeyDownHandler: handler => {
        document.removeEventListener('keydown', handler);
      },
      notifyPageChange: pageIndex => {
        this.props.onPageChange(pageIndex);
      },
      notifyPageSizeChange: pageSize => {
        this.props.onPageSizeChange(pageSize);
      },
      notifyChange: (pageIndex, pageSize) => {
        this.props.onChange(pageIndex, pageSize);
      }
    });
  }

  componentDidMount() {
    this.foundation.init();
  }

  componentWillUnmount() {
    this.foundation.destroy();
  }

  componentDidUpdate(prevProps) {
    const pagerProps = {
      currentPage: this.props.currentPage,
      total: this.props.total,
      pageSize: this.props.pageSize
    };
    let pagerHasChanged = false;

    if (prevProps.currentPage !== this.props.currentPage) {
      pagerHasChanged = true; // this.foundation.updatePage(this.props.currentPage);
    }

    if (prevProps.total !== this.props.total) {
      pagerHasChanged = true;
    }

    if (prevProps.pageSize !== this.props.pageSize) {
      pagerHasChanged = true;
    }

    if (pagerHasChanged) {
      this.foundation.updatePage(pagerProps.currentPage, pagerProps.total, pagerProps.pageSize);
    }
  }

  renderPrevBtn() {
    const {
      prevText
    } = this.props;
    const {
      prevDisabled
    } = this.state;
    const preClassName = classNames({
      ["".concat(prefixCls, "-item")]: true,
      ["".concat(prefixCls, "-prev")]: true,
      ["".concat(prefixCls, "-item-disabled")]: prevDisabled
    });
    return /*#__PURE__*/React.createElement("li", {
      role: "button",
      "aria-disabled": prevDisabled ? true : false,
      "aria-label": "Previous",
      onClick: e => !prevDisabled && this.foundation.goPrev(e),
      className: preClassName,
      "x-semi-prop": "prevText"
    }, prevText || /*#__PURE__*/React.createElement(IconChevronLeft, {
      size: "large"
    }));
  }

  renderNextBtn() {
    const {
      nextText
    } = this.props;
    const {
      nextDisabled
    } = this.state;
    const nextClassName = classNames({
      ["".concat(prefixCls, "-item")]: true,
      ["".concat(prefixCls, "-item-disabled")]: nextDisabled,
      ["".concat(prefixCls, "-next")]: true
    });
    return /*#__PURE__*/React.createElement("li", {
      role: "button",
      "aria-disabled": nextDisabled ? true : false,
      "aria-label": "Next",
      onClick: e => !nextDisabled && this.foundation.goNext(e),
      className: nextClassName,
      "x-semi-prop": "prevText"
    }, nextText || /*#__PURE__*/React.createElement(IconChevronRight, {
      size: "large"
    }));
  }

  renderPageSizeSwitch(locale) {
    // rtl modify the default position
    const {
      direction
    } = this.context;
    const defaultPopoverPosition = direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    const {
      showSizeChanger,
      popoverPosition = defaultPopoverPosition
    } = this.props;
    const {
      pageSize
    } = this.state;
    const switchCls = classNames("".concat(prefixCls, "-switch"));

    if (!showSizeChanger) {
      return null;
    }

    const pageSizeText = locale.pageSize;
    const newPageSizeOpts = this.foundation.pageSizeInOpts();

    const options = _mapInstanceProperty(newPageSizeOpts).call(newPageSizeOpts, size => /*#__PURE__*/React.createElement(Option, {
      value: size,
      key: size
    }, /*#__PURE__*/React.createElement("span", null, "".concat(size, " "), pageSizeText)));

    return /*#__PURE__*/React.createElement("div", {
      className: switchCls
    }, /*#__PURE__*/React.createElement(Select, {
      "aria-label": "Page size selector",
      onChange: newPageSize => this.foundation.changePageSize(newPageSize),
      value: pageSize,
      key: pageSizeText,
      position: popoverPosition || 'bottomRight',
      clickToHide: true,
      dropdownClassName: "".concat(prefixCls, "-select-dropdown")
    }, options));
  }

  renderQuickJump(locale) {
    const {
      showQuickJumper
    } = this.props;
    const {
      quickJumpPage,
      total,
      pageSize
    } = this.state;

    if (!showQuickJumper) {
      return null;
    }

    const totalPageNum = this.foundation._getTotalPageNumber(total, pageSize);

    const isDisabled = totalPageNum === 1;
    const quickJumpCls = classNames({
      ["".concat(prefixCls, "-quickjump")]: true,
      ["".concat(prefixCls, "-quickjump-disabled")]: isDisabled
    });
    return /*#__PURE__*/React.createElement("div", {
      className: quickJumpCls
    }, /*#__PURE__*/React.createElement("span", null, locale.jumpTo), /*#__PURE__*/React.createElement(InputNumber, {
      value: quickJumpPage,
      className: "".concat(prefixCls, "-quickjump-input-number"),
      hideButtons: true,
      disabled: isDisabled,
      onBlur: e => this.foundation.handleQuickJumpBlur(),
      onEnterPress: e => this.foundation.handleQuickJumpEnterPress(e.target.value),
      onChange: v => this.foundation.handleQuickJumpNumberChange(v)
    }), /*#__PURE__*/React.createElement("span", null, locale.page));
  }

  renderPageList() {
    const {
      pageList,
      currentPage,
      restLeftPageList,
      restRightPageList
    } = this.state;
    const {
      popoverPosition,
      popoverZIndex
    } = this.props;
    return _mapInstanceProperty(pageList).call(pageList, (page, i) => {
      var _context3;

      const pageListClassName = classNames("".concat(prefixCls, "-item"), {
        ["".concat(prefixCls, "-item-active")]: currentPage === page // [`${prefixCls}-item-rest-opening`]: (i < 3 && isLeftRestHover && page ==='...') || (i > 3 && isRightRestHover && page === '...')

      });
      const pageEl = /*#__PURE__*/React.createElement("li", {
        key: _concatInstanceProperty(_context3 = "".concat(page)).call(_context3, i),
        onClick: () => this.foundation.goPage(page, i),
        className: pageListClassName,
        "aria-label": page === '...' ? 'More' : "Page ".concat(page),
        "aria-current": currentPage === page ? "page" : false
      }, page);

      if (page === '...') {
        var _context4;

        let content;
        i < 3 ? content = restLeftPageList : content = restRightPageList;
        return /*#__PURE__*/React.createElement(Popover, {
          trigger: "hover",
          // onVisibleChange={visible=>this.handleRestHover(visible, i < 3 ? 'left' : 'right')}
          content: this.renderRestPageList(content),
          key: _concatInstanceProperty(_context4 = "".concat(page)).call(_context4, i),
          position: popoverPosition,
          zIndex: popoverZIndex
        }, pageEl);
      }

      return pageEl;
    });
  }

  renderRestPageList(restList) {
    // The number of pages may be tens of thousands, here is virtualized with the help of react-window
    const {
      direction
    } = this.context;
    const className = classNames("".concat(prefixCls, "-rest-item"));
    const count = restList.length;

    const row = item => {
      var _context5;

      const {
        index,
        style
      } = item;
      const page = restList[index];
      return /*#__PURE__*/React.createElement("div", {
        role: "listitem",
        key: _concatInstanceProperty(_context5 = "".concat(page)).call(_context5, index),
        className: className,
        onClick: () => this.foundation.goPage(page, index),
        style: style,
        "aria-label": "".concat(page)
      }, page);
    };

    const itemHeight = 32;
    const listHeight = count >= 5 ? itemHeight * 5 : itemHeight * count;
    return (
      /*#__PURE__*/
      // @ts-ignore skip type check cause react-window not update with @types/react 18
      React.createElement(List, {
        className: "".concat(prefixCls, "-rest-list"),
        itemData: restList,
        itemSize: itemHeight,
        width: 78,
        itemCount: count,
        height: listHeight,
        style: {
          direction
        }
      }, row)
    );
  }

  renderSmallPage(locale) {
    var _context6;

    const {
      className,
      style,
      hideOnSinglePage,
      hoverShowPageSelect,
      showSizeChanger
    } = this.props;
    const paginationCls = classNames("".concat(prefixCls, "-small"), prefixCls, className);
    const {
      currentPage,
      total,
      pageSize
    } = this.state;
    const totalPageNum = Math.ceil(total / pageSize);

    if (totalPageNum < 2 && hideOnSinglePage && !showSizeChanger) {
      return null;
    }

    const pageNumbers = _Array$from({
      length: Math.ceil(total / pageSize)
    }, (v, i) => i + 1);

    const pageList = this.renderRestPageList(pageNumbers);
    const page = /*#__PURE__*/React.createElement("div", {
      className: _concatInstanceProperty(_context6 = "".concat(prefixCls, "-item ")).call(_context6, prefixCls, "-item-small")
    }, currentPage, "/", totalPageNum, " ");
    return /*#__PURE__*/React.createElement("div", {
      className: paginationCls,
      style: style
    }, this.renderPrevBtn(), hoverShowPageSelect ? /*#__PURE__*/React.createElement(Popover, {
      content: pageList
    }, page) : page, this.renderNextBtn(), this.renderQuickJump(locale));
  }

  renderDefaultPage(locale) {
    const {
      total,
      pageSize
    } = this.state;
    const {
      showTotal,
      className,
      style,
      hideOnSinglePage,
      showSizeChanger
    } = this.props;
    const paginationCls = classNames(className, "".concat(prefixCls));
    const showTotalCls = "".concat(prefixCls, "-total");
    const totalPageNum = Math.ceil(total / pageSize);

    if (totalPageNum < 2 && hideOnSinglePage && !showSizeChanger) {
      return null;
    }

    return /*#__PURE__*/React.createElement("ul", {
      className: paginationCls,
      style: style
    }, showTotal ? /*#__PURE__*/React.createElement("span", {
      className: showTotalCls
    }, locale.total, " ".concat(Math.ceil(total / pageSize), " "), locale.page) : null, this.renderPrevBtn(), this.renderPageList(), this.renderNextBtn(), this.renderPageSizeSwitch(locale), this.renderQuickJump(locale));
  }

  render() {
    const {
      size
    } = this.props;
    return /*#__PURE__*/React.createElement(LocaleConsumer, {
      componentName: "Pagination"
    }, locale => size === 'small' ? this.renderSmallPage(locale) : this.renderDefaultPage(locale));
  }

}
Pagination.contextType = ConfigContext;
Pagination.propTypes = {
  total: PropTypes.number,
  showTotal: PropTypes.bool,
  pageSize: PropTypes.number,
  pageSizeOpts: PropTypes.array,
  size: PropTypes.string,
  currentPage: PropTypes.number,
  defaultCurrentPage: PropTypes.number,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  onChange: PropTypes.func,
  prevText: PropTypes.node,
  nextText: PropTypes.node,
  showSizeChanger: PropTypes.bool,
  popoverZIndex: PropTypes.number,
  popoverPosition: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  hideOnSinglePage: PropTypes.bool,
  hoverShowPageSelect: PropTypes.bool,
  showQuickJumper: PropTypes.bool
};
Pagination.defaultProps = {
  total: 1,
  popoverZIndex: popoverNumbers.DEFAULT_Z_INDEX,
  showTotal: false,
  pageSize: null,
  pageSizeOpts: numbers.PAGE_SIZE_OPTION,
  defaultCurrentPage: 1,
  size: 'default',
  onPageChange: _noop,
  onPageSizeChange: _noop,
  onChange: _noop,
  showSizeChanger: false,
  className: '',
  hideOnSinglePage: false,
  showQuickJumper: false
};